module.exports = __webpack_public_path__ + "static/media/logo_color.314079c9.png";